export default __webpack_public_path__ + "static/media/sort.38cbf820.svg";